export type ManagedRoleCode =
  | 'super_admin'
  | 'administrator'
  | 'senior_admin'
  | 'editor'
  | 'tool_user'
  | 'viewer';

export const ROLE_LEVELS: Record<ManagedRoleCode, number> = {
  super_admin: 100,
  administrator: 90,
  senior_admin: 80,
  editor: 50,
  tool_user: 30,
  viewer: 10,
};

export const ROLE_OPTIONS: Array<{ value: ManagedRoleCode; label: string }> = [
  { value: 'administrator', label: 'Administrator' },
  { value: 'senior_admin', label: 'Üst Yönetim' },
  { value: 'editor', label: 'İçerik Yöneticisi' },
  { value: 'tool_user', label: 'Araç Kullanıcısı' },
  { value: 'viewer', label: 'Görüntüleyici' },
];

export function isKnownManagedRole(
  roleCode?: string | null
): roleCode is ManagedRoleCode {
  return Boolean(roleCode && roleCode in ROLE_LEVELS);
}

export function getRoleLevel(roleCode?: string | null) {
  if (!roleCode) return 0;
  return isKnownManagedRole(roleCode) ? ROLE_LEVELS[roleCode] : 0;
}

export function isAdministratorRole(roleCode?: string | null) {
  return roleCode === 'super_admin' || roleCode === 'administrator';
}

export function isPrivilegedRole(roleCode?: string | null) {
  return getRoleLevel(roleCode) >= ROLE_LEVELS.senior_admin;
}

export function canManageRoleHierarchy(
  actorRoleCode?: string | null,
  targetRoleCode?: string | null
) {
  return getRoleLevel(actorRoleCode) > getRoleLevel(targetRoleCode);
}

export function canAssignRoleCode(
  actorRoleCode?: string | null,
  desiredRoleCode?: string | null
) {
  return getRoleLevel(actorRoleCode) > getRoleLevel(desiredRoleCode);
}
